module.exports = __webpack_public_path__ + "img/5.b3f12983.jpg";